const IndependentRoutes = {
    WIDGETS_PAGE: "/widgets",
}

const DashboardRoutes = {
    MAIN_PAGE: "/",
    ECOMMERCE_PAGE: "/dashboard/ecommerce",
    PROJECT_PAGE: "/dashboard/project",
    CRYPTO_PAGE: "/dashboard/crypto",
    EDUCATION_PAGE: "/dashboard/education",
}

const AppsRoutes = {
    CALENDAR_PAGE: "/apps/calendar",
    PROFILE_PAGE: "/apps/profile-page/profile",
    SETTING_PAGE: "/apps/profile-page/setting",
    PROJECTS_PAGE: "/apps/e-shop/projects-page/projects",
    PROJECTS_DETAILS_PAGE: "/apps/e-shop/projects-page/project-details",
    TODO_PAGE: '/apps/todo',
    TEAM_PAGE: "/apps/team",
    API_PAGE: '/apps/api',
    MCP_SERVER_PAGE: '/apps/mcp-server',
    TICKET_PAGE: "/apps/ticket-page/ticket",
    TICKET_DETAILS_PAGE: "/apps/ticket-page/ticket-details",
    Email_PAGE: "/apps/email-page/email",
    READ_EMAIL_PAGE: "/apps/email-page/read_email",
    SHOP_PRODUCT_PAGE: "/apps/e-shop/product",
    SHOP_CART_PAGE: "/apps/e-shop/cart",
    SHOP_ADD_PRODUCT_PAGE: "/apps/e-shop/add-product",
    SHOP_PRODUCT_DETAILS_PAGE: "/apps/e-shop/product-details",
    SHOP_PRODUCT_LIST_PAGE: "/apps/e-shop/product-list",
    SHOP_ORDERS_PAGE: "/apps/e-shop/orders",
    SHOP_ORDERS_DETAILS_PAGE: "/apps/e-shop/orders-details",
    SHOP_ORDERS_LIST_PAGE: "/apps/e-shop/orders-list",
    SHOP_CHECKOUT_PAGE: "/apps/e-shop/checkout",
    SHOP_WISHLIST_PAGE: "/apps/e-shop/wishlist",
    INVOICE_PAGE: "/apps/invoice",
    CHAT_PAGE: "/apps/chat",
    FILE_MANAGER_PAGE: '/apps/file-manager',
    BOOKMARK_PAGE: '/apps/bookmark',
    KANBAN_BOARD_PAGE: "/apps/kanban_board",
    TIMELINE_PAGE: "/apps/timeline",
    FAQ_PAGE: "/apps/faq",
    PRICING_PAGE: "/apps/pricing",
    GALLERY_PAGE: "/apps/gallery",
    BLOG_PAGE: "/apps/blog-page/blog",
    BLOG_DETAILS_PAGE: "/apps/blog-page/blog-details",
    Add_BLOG_PAGE: "/apps/blog-page/ADD-BLOG",
    ANALYSIS_RESULTS_NO_AI: "/apps/analysis-results-no-ai",
}

const UiKitRoutes = {
    CHEATSHEET_PAGE:"/ui-kits/cheatsheet",
    ALERT_PAGE:"/ui-kits/alert",
    BADGE_PAGE:"/ui-kits/badge",
    BUTTON_PAGE:"/ui-kits/button",
    CARD_PAGE:"/ui-kits/card",
    DROPDOWN_PAGE:"/ui-kits/dropdown",
    GRID_PAGE:"/ui-kits/grid",
    AVATAR_PAGE:"/ui-kits/avtar",
    TAB_PAGE:"/ui-kits/tabs",
    ACCORDION_PAGE:"/ui-kits/accordions",
    PROGRESS_PAGE:"/ui-kits/progress",
    NOTIFICATION_PAGE:"/ui-kits/notification",
    LIST_PAGE:"/ui-kits/list",
    HELPER_CLASSES_PAGE:"/ui-kits/helper-classes",
    BACKGROUND_PAGE:"/ui-kits/background",
    DIVIDER_PAGE:"/ui-kits/divider",
    RIBBONS_PAGE:"/ui-kits/ribbons",
    EDITOR_PAGE:"/ui-kits/editor",
    COLLAPSE_PAGE:"/ui-kits/collapse",
    FOOTER_PAGE:"/ui-kits/footer",
    SHADOW_PAGE:"/ui-kits/shadow",
    WRAPPER_PAGE:"/ui-kits/wrapper",
    BULLET_PAGE:"/ui-kits/bullet",
    PLACEHOLDER_PAGE:"/ui-kits/placeholder",
    ALIGNMENT_PAGE:"/ui-kits/alignment"
};

const AdvanceUiRoutes = {
    MODAL_PAGE:"/advance-ui/modal",
    OFF_CANVAS_PAGE:"/advance-ui/offcanvas",
    SWEETALERT_PAGE:"/advance-ui/sweetalert",
    SCROLLBAR_PAGE:"/advance-ui/scrollbar",
    SPINNER_PAGE:"/advance-ui/spinner",
    ANIMATION_PAGE:"/advance-ui/animation",
    VIDEO_EMBED_PAGE:"/advance-ui/video-embed",
    TOUR_PAGE:"/advance-ui/tour",
    SLIDER_PAGE:"/advance-ui/slider",
    BOOTSTRAP_SLIDER_PAGE:"/advance-ui/bootstrap-slider",
    SCROLLSPY_PAGE:"/advance-ui/scrollspy",
    TOOLTIP_POPOVERS_PAGE:"/advance-ui/tooltip-popovers",
    RATINGS_PAGE:"/advance-ui/ratings",
    PRISMJS_PAGE:"/advance-ui/prismjs",
    COUNT_DOWN_PAGE:"/advance-ui/count-down",
    COUNT_UP_PAGE:"/advance-ui/count-up",
    DRAGGABLE_PAGE:"/advance-ui/draggable",
    TREE_VIEW_PAGE:"/advance-ui/tree-view",
    BLOG_UI_PAGE:"/advance-ui/block-ui",

};

const  IconsRoutes = {
    FONT_AWESOME_PAGE: "/icons/fontawesome",
    FLAG_ICONS_PAGE: "/icons/flag-icons",
    TABLER_ICONS_PAGE: "/icons/tabler-icons",
    WEATHER_ICONS_PAGE: "/icons/weather-icons",
    ANIMATED_ICONS_PAGE: "/icons/animated-icons",
    ICONOIR_ICONS_PAGE: "/icons/iconoir-icons",
    PHOSPHOR_ICONS_PAGE: "/icons/phosphor-icons",
}

const MISC_PAGE = '/misc';

const mapRoutes = {
    GOOGLE_MAP: "/map/google-map",
    LEAFLET_MAP: "/map/leaflet-map",
    VECTOR_MAP: "/map/vector-map",
}

const chartRoutes = {
    CHART_JS_PAGE: "/chart/chart-js",
}

const apexChartRoutes = {
    LINE_PAGE: "/apexcharts/line",
    AREA_PAGE: "/apexcharts/area",
    COLUMN_PAGE: "/apexcharts/column",
    BAR_PAGE: "/apexcharts/bar",
    MIXED_PAGE: "/apexcharts/mixed",
    TIMELINE_PAGE: "/apexcharts/timeline",
    CANDLESTICK_PAGE: "/apexcharts/candlestick",
    BOXPLOT_PAGE: "/apexcharts/boxplot",
    BUBBLE_PAGE: "/apexcharts/bubble",
    SCATTER_PAGE: "/apexcharts/scatter",
    HEATMAP_PAGE: "/apexcharts/heatmap",
    TREEMAP_PAGE: "/apexcharts/treemap",
    PIE_PAGE: "/apexcharts/pie",
    RADIAL_BAR_PAGE: "/apexcharts/radial-bar",
    RADAR_PAGE: "/apexcharts/radar",
}

const AuthRoutes = {
    AUTH_SIGN_IN : "/auth/sign-in",
    AUTH_SIGN_IN_IMG : "/auth/sign-in-img",
    AUTH_SIGN_UP : "/auth/sign-up",
    AUTH_SIGN_UP_IMG : "/auth/sign-up-img",
    AUTH_PASSWORD_RESET:"/auth/password-reset",
    AUTH_PASSWORD_RESET_IMG : "/auth/password-reset-img",
    AUTH_PASSWORD_CREATE : "/auth/password-create",
    AUTH_PASSWORD_CREATE_IMG : "/auth/password-create-img",
    AUTH_LOCK_SCREEN : "/auth/lock-screen",
    AUTH_LOCK_SCREEN_IMG : "/auth/lock-screen-img",
    AUTH_VERIFICATION : "/auth/two-step-verification",
    AUTH_VERIFICATION_IMG : "/auth/two-step-verification-img",
}

const ErrorRoutes = {
    ERROR_400 : "/error/400",
    ERROR_403 : "/error/403",
    ERROR_404 : "/error/404",
    ERROR_500 : "/error/500",
    ERROR_503 : "/error/503",
}
const OtherRoutes = {
    OTHER_BLANK_PAGE: "/other/blank",
    MAINTENANCE_PAGE: "/other/maintenance",
    OTHER_LANDING_PAGE: "/other/landing-page",
    COMING_SOON: "/other/coming-soon",
    SITE_MAP: "/other/sitemap",
    PRIVACY_POLICY : "/other/privacy-policy",
    TERMS_CONDITION:"/other/terms-condition"
}
const BlankRoutes = {
    ANOTHER_BLANK_PAGE: "/level/blank",

}

const TableRoutes = {
    BASIC_TABLE : '/table/basic-table',
    DATA_TABLE : '/table/data-table',
    LIST_JS_TABLE : '/table/listjs-table',
    ADVANCE_TABLE : '/table/advance-table',
}

const FormElementRoutes = {
    FORM_VALIDATION : '/form-elements/form-validation',
    BASE_INPUT : '/form-elements/base-input',
    CHECKBOX_RADIO : '/form-elements/checkbox-radio',
    INPUT_GROUPS : '/form-elements/input-group',
    INPUT_MASKS : '/form-elements/input-mask',
    FLOATING_LABEL : '/form-elements/floating-label',
    DATE_TIME_PICKER : '/form-elements/date-time-picker',
    TOUCH_SPINE : '/form-elements/touch-spine',
    FORM_SELECT : '/form-elements/form-select',
    SWITCH: '/form-elements/switch',
    RANGE_SLIDER: '/form-elements/range-slider',
    TYPEAHEAD: '/form-elements/typeahead',
    FORM_TEXTAREA: '/form-elements/form-textarea',
    FORM_CLIPBOARD: '/form-elements/form-clipboard',
    FILE_UPLOAD: '/form-elements/file-upload',
    DUAL_LIST_BOX: '/form-elements/dual-list-box',
    DEFAULT_FORMS: '/form-elements/default-form',
}

const ReadyUseRoutes = {
    READY_FORM_WIZARDS : "/ready-to-use/form-wizards",
    READY_FORM_WIZARDS_1: "/ready-to-use/form-wizards-1",
    READY_FORM_WIZARDS_2: "/ready-to-use/form-wizards-2",
    READY_USE_FORM: "/ready-to-use/ready-form",
    READY_USE_TABLE:"/ready-to-use/ready-table",
}

export {
    DashboardRoutes,
    AppsRoutes,
    BlankRoutes,
    IndependentRoutes,
    UiKitRoutes,
    AdvanceUiRoutes,
    IconsRoutes,
    MISC_PAGE,
    mapRoutes,
    chartRoutes,
    apexChartRoutes,
    AuthRoutes,
    ErrorRoutes,
    OtherRoutes,
    TableRoutes,
    FormElementRoutes,
    ReadyUseRoutes
}